import { EMAIL_URL } from "../../helpers/api.routes";
import { instance, requests } from "../../helpers/api.services";

export const EmailService = {
  getAll: (params: any) => requests.get(`${EMAIL_URL}`, params),
  getEmail: (id: number) => requests.get(`${EMAIL_URL}/${id}`, {}),
  exportEmails: (params: any) =>
    instance.get(`${EMAIL_URL}/export`, {
      params,
      responseType: 'blob',
    }),
};

